import React, { Component } from 'react'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import '../../styles/css/login.css'
import {
    login,
    getSession
} from '../../modules/auth'

class Login extends Component {
    
    constructor(props){
        super(props)
        this.state = {
            user: {}
        }
    }

    componentWillMount() {
        if(localStorage.getItem('loggedIn')) {
            this.props.changePage('/music')
        }
    }

    handleInputChange = e => {
        this.setState({
            user: {
                ...this.state.user,
                [e.target.name]: e.target.value
            }
        })
    }

    handleSubmission = e => {
        e.preventDefault()
        this.props.login(this.state.user)
    }

    render() {
        const { message } = this.props
        return(
            <div className="login">
                <div className="login-inner">
                    {message && 
                        <h1>{message}</h1>
                    }
                    <form onSubmit={this.handleSubmission}>
                        <input name="username" onChange={this.handleInputChange} type="text" placeholder="Username" required/>
                        <input name="password" onChange={this.handleInputChange} type="password" placeholder="Password" required/>
                        <button>Login</button>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    loggedIn: state.auth.loggedIn,
    message: state.auth.message
})

const mapDispatchToProps = dispatch => bindActionCreators({
    login,
    getSession,
    changePage: page => push(page)
},dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login)


// WEBPACK FOOTER //
// ./src/containers/login/index.js